import type { FC } from 'react';

import type { PanelBlockProps } from '@eshop/templates/blocks';
import CategoriesMenu, { CategoriesMenuDrawerProvider } from '@eshop/pages/categories/CategoriesMenu';

export const SoftCommercePanelLayoutBlock: FC<PanelBlockProps> = ({ renderSlot }) => (
  <CategoriesMenuDrawerProvider>
    <div className="catalogue-panel__layout">
      <aside className="catalogue-panel__sidebar" aria-label="Filtros del catálogo">
        <CategoriesMenu variant="soft-commerce" withDrawer />
      </aside>
      <div className="catalogue-panel__main">
        <div className="soft-commerce-panel-head">
          {renderSlot?.('heading')}
          <div className="soft-commerce-top-filters" data-section="topFilters">
            {renderSlot?.('topFilters')}
          </div>
        </div>
        {renderSlot?.('grid')}
        {renderSlot?.('empty')}
        {renderSlot?.('pagination')}
      </div>
    </div>
  </CategoriesMenuDrawerProvider>
);

export default SoftCommercePanelLayoutBlock;
